import React, { Component } from "react";
import { leadType } from "../../app";
import Accordion from "../../common/components/accordion";
import FormStep from "../../common/components/formStep";
import HdfcHeader from "../../common/components/pageBlocks/hdfcHeader";
import FinalSubmit from "../../common/components/pageBlocks/vehicleDetails/finalSubmit";
import MotorInsurance from "../../common/components/pageBlocks/vehicleDetails/motorInsurance";
import VehicleInfo from "../../common/components/pageBlocks/vehicleDetails/vehicleInfo";
import commonContext, { AppContext } from "../../common/context/common";
import { Qm10SecApis } from "../apis/qm10SecApis";

interface IProps {
    history: any;
}
interface IState {}
export default class VehicleDetails extends Component<IProps, IState> {
    static contextType = commonContext;
    lead: leadType;
    setLead: Function;
    apis: Qm10SecApis;
    steps = [
        { title: "Vehicle", active: true },
        { title: "Loan" },
        { title: "Review" },
        { title: "Personal" },
        { title: "Confirmation" },
    ];
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    handleOnSubmit = async (e) => {
        e.preventDefault();
        this.apis = (this.context as AppContext).apis as Qm10SecApis;
        this.lead = (this.context as AppContext).lead as leadType;
        this.setLead = (this.context as AppContext).setLead;
        await this.setLead({ loadingBtn: "loadingBtn" });
        const apiData = await this.apis.updateCarInfo({
            ...this.lead,
            existingLoanAccount: this.lead.existingLoanAccountNumber,
            shardKey: "qm",
        });
        await this.setLead({ loadingBtn: "" });

        if (apiData.error?.error) {
            console.log(apiData.error);
        }
        if (apiData.result) {
            return this.props.history.push("/loan-details");
        }
    };

    render() {
        return (
            <>
                <div className="wrapper">
                    <HdfcHeader />
                    <section className="vehicle-wrap mt-110">
                        <form onSubmit={(e) => this.handleOnSubmit(e)}>
                            <div className="container mx-auto px-5">
                                <FormStep steps={this.steps} />
                                <VehicleInfo />
                            </div>
                            <MotorInsurance />
                            <FinalSubmit />
                        </form>
                    </section>
                </div>
            </>
        );
    }
}
